import React from 'react';
import lockup from '../../assets/brand-ng/comtev-ng-lockup.svg';
import mark from '../../assets/brand-ng/comtev-ng-mark.svg';

/* The balloon lockup started as the comtev.ng brand. As of 2026-09-21 it is the
   Comtev logo on both domains: comtev.com renders the same artwork through
   src/components/BrandLogo.tsx (copies live in src/assets/brand/balloon, with a
   bone-wordmark version for dark surfaces). Keep the two sets identical. */

interface BrandLogoNgProps {
    variant?: 'lockup' | 'mark';
    height?: number;
    className?: string;
}

const BrandLogoNg: React.FC<BrandLogoNgProps> = ({
    variant = 'lockup',
    height = 26,
    className,
}) => (
    <img
        src={variant === 'lockup' ? lockup : mark}
        alt="comtev"
        height={height}
        className={className}
        style={{ height, width: 'auto', display: 'block' }}
    />
);

export default BrandLogoNg;
